import React from 'react';
import cx from 'classnames';

import { useSiteContext, useFilters } from '@lib/context';

import Exit from '@svg/exit-white.svg';
import Chevron from '@svg/chevron-down-white.svg';

export const FiltersInner = ({
  setFiltersOpen,
  filtersOpen,
  setStep,
  artists,
  venues,
}) => {
  const { state } = useSiteContext();
  const { nukeFilters } = useFilters();

  return (
    <div
      className={cx(
        'bg-teal w-full fixed left-0 top-0 transition-standard z-50',
        {
          'opacity-0 pointer-events-none': !filtersOpen,
          'opacity-100': filtersOpen,
        },
      )}>
      <div className='min-h-screen flex flex-col items-center justify-center'>
        <div className='absolute top-10 right-gutter'>
          <button
            onClick={() => setFiltersOpen(false)}
            className='w-12 h-12 rounded-full bg-white bg-opacity-10 flex items-center justify-center'>
            <Exit className='p-[3px]' />
          </button>
        </div>
        <div className='w-full px-gutter'>
          <span className='blockH2 text-white mb-10 block text-center'>
            Filter {artists ? 'Artists' : venues ? 'Venues' : 'Events'}
          </span>
          <div className='flex flex-col gap-y-6 text-white blockH5'>
            {artists ? (
              <button
                onClick={() => setStep('instruments')}
                className='flex items-center justify-between border-b border-white pb-3'>
                <span>
                  {state?.artistFilters?.instruments?.length > 0
                    ? state?.artistFilters?.instruments?.length === 1
                      ? `${state?.artistFilters?.instruments?.length} Instrument`
                      : `${state?.artistFilters?.instruments?.length} Instruments`
                    : `All Instruments`}
                </span>
                <Chevron className='w-4 h-4' />
              </button>
            ) : venues ? (
              <button
                onClick={() => setStep('locations')}
                className='flex items-center justify-between border-b border-white pb-3'>
                <span>
                  {state?.filters?.locations?.length > 0
                    ? `${state?.filters?.locations?.length} Locations`
                    : `Anywhere`}
                </span>
                <Chevron className='w-4 h-4' />
              </button>
            ) : (
              <>
                <button
                  onClick={() => setStep('series')}
                  className='flex items-center justify-between border-b border-white pb-3'>
                  <span>
                    {state?.filters?.series?.length > 0
                      ? `${state?.filters?.series?.length} Series`
                      : `All Series`}
                  </span>
                  <Chevron className='w-4 h-4' />
                </button>
                <button
                  onClick={() => setStep('dates')}
                  className='flex items-center justify-between border-b border-white pb-3'>
                  <span>
                    {state?.filters?.dates?.to
                      ? `${new Date(
                          state?.filters?.dates?.from,
                        ).toLocaleDateString('en-US')} - ${new Date(
                          state?.filters?.dates?.to,
                        ).toLocaleDateString('en-US')}`
                      : `Anytime`}
                  </span>
                  <Chevron className='w-4 h-4' />
                </button>
                <button
                  onClick={() => setStep('locations')}
                  className='flex items-center justify-between border-b border-white pb-3'>
                  <span>
                    {state?.filters?.locations?.length > 0
                      ? state?.filters?.locations?.length === 1
                        ? `${state?.filters?.locations?.length} Location`
                        : `${state?.filters?.locations?.length} Locations`
                      : `Anywhere`}
                  </span>
                  <Chevron className='w-4 h-4' />
                </button>
                <button
                  onClick={() => setStep('artists')}
                  className='flex items-center justify-between border-b border-white pb-3'>
                  <span>
                    {state?.filters?.artists?.length > 0
                      ? state?.filters?.artists?.length === 1
                        ? `${state?.filters?.artists?.length} Artist`
                        : `${state?.filters?.artists?.length} Artists`
                      : `Anyone`}
                  </span>
                  <Chevron className='w-4 h-4' />
                </button>
              </>
            )}
          </div>
          <div className='flex gap-x-4 items-center justify-center mt-12'>
            <button
              onClick={() => nukeFilters()}
              className='btn-standard bg-white bg-opacity-10 text-white hover:!text-teal'>
              Clear
            </button>
            <button
              onClick={() => setFiltersOpen(false)}
              className='btn-standard bg-white bg-opacity-10 text-white'>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
